var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-download",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
          defaultGrade: false,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentFile !== null
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-download-content",
                        },
                        [
                          _vm.currentInfo !== "" && !_vm.userHasDownloaded
                            ? _c(
                                "div",
                                {
                                  staticClass: "messagebox messagebox_info",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentInfo) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentSuccess !== "" && _vm.userHasDownloaded
                            ? _c(
                                "div",
                                {
                                  staticClass: "messagebox messagebox_info",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentSuccess) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-download-file-item",
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    download: _vm.currentFile.name,
                                    title: _vm.$gettext("Datei herunterladen"),
                                    href: _vm.currentFile.download_url,
                                  },
                                  on: {
                                    click: _vm.handleDownload,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cw-block-file-info",
                                      class: [
                                        "cw-block-file-icon-" +
                                          _vm.currentFile.icon,
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.currentFile.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "cw-block-download-content",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "cw-block-download-file-item-not-available",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cw-block-file-info cw-block-file-icon-none",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Datei ist nicht verfügbar"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Datei"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Überschrift")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentTitle,
                                          expression: "currentTitle",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentTitle,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentTitle = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("Datei")) +
                                          "\n                            "
                                      ),
                                      _c("studip-file-chooser", {
                                        attrs: {
                                          selectable: "file",
                                          courseId: _vm.context.id,
                                          userId: _vm.userId,
                                          excludedCourseFolderTypes:
                                            _vm.excludedCourseFolderTypes,
                                        },
                                        model: {
                                          value: _vm.currentFileId,
                                          callback: function callback($$v) {
                                            _vm.currentFileId = $$v
                                          },
                                          expression: "currentFileId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Infobox"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext("Infobox vor Download")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentInfo,
                                          expression: "currentInfo",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentInfo,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentInfo = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext("Infobox nach Download")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentSuccess,
                                          expression: "currentSuccess",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentSuccess,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentSuccess =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 2,
                                name: _vm.$gettext("Fortschritt"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Fortschritt erst beim Herunterladen"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentGrade,
                                            expression: "currentGrade",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentGrade = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "false",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Download-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }